// extracted by css-extract-rspack-plugin
export default {"taxonomyList":"taxonomyList-FWX3Yc"};